import { ReactNode } from "react";

type MobileHeaderProps = {
  title: string;
  rightAction?: ReactNode;
};

/**
 * モバイル版 AppBar（sticky / 半透明白背景）
 * タイトル + 右側アイコンボタンの 2 ピース構成
 *
 * 2026-09-16 更新:showNotification / Bell icon 廃止。
 * - ユーザー判断:Mobile Dashboard / 各 page 顶部 bell icon は product value 薄
 * - refresh / back / menu など page-specific な右ボタンは rightAction slot で渡す
 * - rightAction は必ず `.mobile-appbar-actions` で wrap されて header 右端に配置される
 */
export const MobileHeader = ({ title, rightAction }: MobileHeaderProps) => {
  return (
    <header className="mobile-appbar">
      <h1 className="mobile-appbar-title">{title}</h1>
      {rightAction ? (
        <div className="mobile-appbar-actions">{rightAction}</div>
      ) : null}
    </header>
  );
};
